import React from "react";
import { ObserveState } from "../StateManagement/ObserveState";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { UITextList } from "../BuildlingBlocks/UITextList";
import { SxProps } from "@mui/material";
import { getPropertyEditorValidationIssues, PropertyEditorValidationTooltip } from "./PropertyEditorValidationTooltip";

export interface PropertyEditorTextListInterface {
    editObject: object;
    propertyName: string;
    placeholder?: string;
    label?: string;
    hint?: string;
    autoFocus?: boolean;
    validValues?: string[];
    onChange?: () => void;
    sx?: SxProps;
    inputSx?: SxProps;
    error?: string;
    ignoreDesignerValidation?: boolean;
}

export const PropertyEditorTextList: React.FC<PropertyEditorTextListInterface> = (
    props: PropertyEditorTextListInterface,
) => {
    const onChange = (val: string[]) => {
        Reflect.set(props.editObject, props.propertyName, val);

        StateManager.propertyChanged(props.editObject, props.propertyName);
        if (props.onChange) props.onChange();
    };

    return (
        <ObserveState
            listenTo={props.editObject}
            properties={[props.propertyName]}
            control={() => {
                const value = Reflect.get(props.editObject, props.propertyName) ?? [];
                let validationIssues = getPropertyEditorValidationIssues(
                    props.editObject,
                    props.propertyName,
                    props.error,
                );

                return (
                    <PropertyEditorValidationTooltip
                        editObject={props.editObject}
                        propertyName={props.propertyName}
                        error={validationIssues}
                    >
                        <UITextList
                            value={value || []}
                            onChange={onChange}
                            placeholder={props.placeholder}
                            label={props.label}
                            hint={props.hint}
                            error={validationIssues?.message}
                            autoFocus={props.autoFocus}
                            validValues={props.validValues}
                            sx={props.sx}
                            inputSx={props.inputSx}
                        />
                    </PropertyEditorValidationTooltip>
                );
            }}
        />
    );
};
